import { render, staticRenderFns } from "./HeaderInformationNavigationKle.vue?vue&type=template&id=a452a056&scoped=true"
import script from "./HeaderInformationNavigationKle.vue?vue&type=script&lang=ts"
export * from "./HeaderInformationNavigationKle.vue?vue&type=script&lang=ts"
import style0 from "./HeaderInformationNavigationKle.vue?vue&type=style&index=0&id=a452a056&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a452a056",
  null
  
)

export default component.exports